import Modal from '..';
import useStore from '../../Hooks/useStore';
import Form from '../../Form';
import Label from '../../Label';
import { useSnackbar } from 'notistack';

export interface RecoverPasswordModalProps {}

const ConfirmBannerFormsDeletion = ({}: RecoverPasswordModalProps) => {
  const [getters, setters] = useStore();
  const {
    modal: { getModal },
    banner: { getBanner },
  } = getters;
  const {
    modal: { closeSingleModal },
    form: { resetRecoverForm },
    banner: { filterFormBanners, setBanner, deleteSelectedFormBanners },
  } = setters;
  const { enqueueSnackbar } = useSnackbar();

  const isOpen = getModal('single.confirmBannerFormsDeletion');
  const onClose = () => {
    closeSingleModal('confirmBannerFormsDeletion');
    resetRecoverForm();
  };
  const numberOfForms = getBanner('formCheck').filter(
    (elemento) => elemento === true,
  ).length;
  const deleteLoading = getBanner('status.deleteFormBanners') === 'pending';

  const handleDelete = () => {
    deleteSelectedFormBanners()
      .then(() => {
        setBanner({
          field: 'formCheck',
          value: getBanner('formCheck').map(() => false),
        });
        enqueueSnackbar(
          `${
            numberOfForms === 1 ? 'Cartaz excluído' : 'Cartazes excluídos'
          } com sucesso`,
          { variant: 'success' },
        );
        filterFormBanners();
        onClose();
      })
      .catch(() => {
        enqueueSnackbar(
          `Houve uma falha na exclusão ${
            numberOfForms === 1 ? 'do cartaz' : 'dos cartazes'
          }`,
          { variant: 'error' },
        );
      });
  };
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      headerTitle="Confirmar Exclusão"
      height={'auto'}
      width={'40vw'}
    >
      <Label
        style={{
          fontSize: '24px',
          margin: '10px 0 30px 20px',
        }}
      >
        Tem certeza que deseja excluir {numberOfForms}{' '}
        {numberOfForms === 1 ? 'lote' : 'lotes'}?
      </Label>
      <Form.Button
        style={{
          height: '55px',
          width: '200px',
          margin: 'auto auto 20px auto',
          padding: '0.5rem 2rem 0.5rem 2rem',
          color: 'white',
          fontWeight: 400,
          fontSize: '24px',
          background: '#11465D',
          borderRadius: '10px',
        }}
        onClick={handleDelete}
        loading={deleteLoading}
      >
        Confirmar
      </Form.Button>
    </Modal>
  );
};

export default ConfirmBannerFormsDeletion;
